<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>Motherless</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="tx"><br/><br/><br/><br/></p>
<p class="txc" id="p0008-02-1"><i>One day the ocean left us.</i></p>
<p class="txc" id="p0008-02-2"><i>She unplugged the drain </i><br/><i>And ran out </i><br/><i>Took her lullaby waters and salt perfume </i><br/><i>To a less demanding world.</i></p>
<p class="txc" id="p0008-03-4"><i><br/>Now we abandoned boats tilt in crusty sand </i><br/><i>Punished </i><br/><i>Guilty of needing the sea </i><br/><br/></p>
<p class="txc"><i>But </i></p>
<p class="txc"><i>Underneath one half-buried hull </i><br/><i>Gritty grains still hold water. </i></p>
<p class="txc" id="p0008-05-6"><i>They are wet enough to grow belief </i><br/><i>That truly the ocean once was here </i><br/><i>And that even now </i><br/><i>She remains.</i></p>
<p class="txr1">—D<span class="small">YLAN</span> B<span class="small">ECKER</span>, “M<span class="small">OTHER</span>” <span class="small">FROM</span> <i>H<span class="small">OW</span> <span class="small"><i>TO</i></span> S<span class="small">URVIVE</span> P<span class="small">EOPLE</span> </i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter3.vue?2be6feb7